// Copyright © 2021 Move Closer

import { Image } from '../../_contracts'

export enum Source {
  PAP = 'PAP',
  PAPnD24 = 'PAPnD24',
  MSPO = 'MSPO',
  Militarnyi = 'Militarnyi'
}

export interface SourceDetails {
  image?: Image;
  newTab: boolean;
  useSite: boolean;
  url?: string;
}

export type SourceMap = {
  [name in Source]: SourceDetails;
}
